import $ from 'jquery';

$(function () {
  const $megaLinks = $(
    'li.mega-menu > a:first-child, li.mega-menu > span:first-child'
  );
  const $searchToggle = $('.search-dropdown__toggle');
  const $megaMenus = $('li.mega-menu');
  const $searchMenu = $('#nav-site-search');
  const $searchWrapper = $('.search-toggle-wrapper');
  const $overlay = $('.search-overlay');

  $megaLinks.attr('aria-haspopup', 'true').attr('aria-expanded', 'false');
  $megaLinks.filter('span').attr('role', 'button').attr('tabindex', '0');

  // Close all menus
  function closeAllMenus() {
    $megaMenus.removeClass('active');
    $megaLinks.attr('aria-expanded', 'false');
    $searchMenu.removeClass('search-active');
    $searchWrapper.removeClass('open');
    $overlay.removeClass('search-overlay--active');
  }

  // Mega Menu Toggle
  $megaLinks.on('click', function (e) {
    const $li = $(this).parent();
    const isAlreadyOpen = $li.hasClass('active');

    e.preventDefault();
    closeAllMenus();

    if (!isAlreadyOpen) {
      $li.addClass('active');
      $(this).attr('aria-expanded', 'true');
      $overlay.addClass('search-overlay--active');
    }
  });

  $megaLinks.on('keydown', function (e) {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      $(this).trigger('click');
    }
  });

  // Search Toggle
  $searchToggle.on('click', function (e) {
    const isOpen = $searchMenu.hasClass('search-active');

    e.preventDefault();
    closeAllMenus();

    if (!isOpen) {
      $searchMenu.addClass('search-active');
      $searchWrapper.addClass('open');
      $overlay.addClass('search-overlay--active');
    }
  });

  // Click Outside to Close
  $(document).on('click', function (e) {
    const isInsideMega = $(e.target).closest('li.mega-menu').length > 0;
    const isInsideSearch = $(e.target).closest('#nav-site-search, .search-dropdown__toggle').length > 0;

    if (!isInsideMega && !isInsideSearch) {
      closeAllMenus();
    }
  });

  // Escape key to close all
  $(document).on('keydown', function (e) {
    if (e.key === 'Escape') {
      closeAllMenus();
    }
  });
});
